import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../../utils";
const badgeVariants = cva("inline-flex items-center border text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2", {
    variants: {
        variant: {
            default: "border-transparent bg-primary text-primary-foreground",
            secondary: "border-transparent bg-secondary text-secondary-foreground",
            destructive: "border-transparent bg-destructive text-destructive-foreground",
            outline: "text-foreground border-border"
        },
        shape: {
            pill: "rounded-full px-2.5 py-0.5",
            rounded: "rounded-md px-2.5 py-0.5",
            circle: "rounded-full p-0 justify-center"
        },
        colorScheme: {
            none: "",
            // Soft pastel colors with matching text (for random assignment)
            blue: "bg-blue-50 border-blue-100 text-blue-600",
            indigo: "bg-indigo-50 border-indigo-100 text-indigo-600",
            violet: "bg-violet-50 border-violet-100 text-violet-600",
            purple: "bg-purple-50 border-purple-100 text-purple-600",
            green: "bg-emerald-50 border-emerald-100 text-emerald-600",
            amber: "bg-amber-50 border-amber-100 text-amber-600",
            cyan: "bg-cyan-50 border-cyan-100 text-cyan-600",
            rose: "bg-rose-50 border-rose-100 text-rose-600",
            teal: "bg-teal-50 border-teal-100 text-teal-600",
            // Semantic colors (for status badges)
            success: "bg-positive-surface border-positive-line text-positive",
            warning: "bg-warning-surface border-warning-line text-warning",
            error: "bg-danger-surface border-danger-line text-danger",
            // 'neutral' and 'gray' are aliases for backward compatibility
            neutral: "bg-muted border-line text-muted-foreground",
            gray: "bg-muted border-line text-muted-foreground",
            // Visually quiet pill against a non-white surface
            plain: "bg-white border-border text-foreground"
        },
        size: {
            default: "",
            sm: "text-3xs",
            lg: "text-sm"
        }
    },
    compoundVariants: [
        {
            shape: "circle",
            size: "default",
            class: "h-6 w-6 min-w-6"
        },
        {
            shape: "circle",
            size: "sm",
            class: "h-5 w-5 min-w-5"
        },
        {
            shape: "circle",
            size: "lg",
            class: "h-7 w-7 min-w-7"
        }
    ],
    defaultVariants: {
        variant: "default",
        shape: "pill",
        colorScheme: "none",
        size: "default"
    }
});
function Badge({ className, variant, shape, colorScheme, size, ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn(badgeVariants({
            variant,
            shape,
            colorScheme,
            size
        }), className),
        ...props
    });
}
export { Badge, badgeVariants };

//# sourceMappingURL=badge.js.map